import { useEffect, useRef, useState } from "react";
import { Card, Form, message as messageNoti } from "antd";
import { Link, useSearchParams } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { useTranslation } from "react-i18next";
import { FormInstance } from "antd/lib";
import api from "../../hooks/api";
import { pathAPI } from "../../utils/pathApi";
import { Box } from "@mui/material";
import LightScope from "../../theme/LightScope";
import ActionButton from "../../components/common/buttons/ActionButton";
import PasswordField from "../../components/common/fields/PasswordField";

const ResetPassword = () => {
  const { isLogin } = useAuth();
  const formRef = useRef<FormInstance>(null);
  const { i18n, t } = useTranslation();
  const [message, setMessage] = useState("");

  const [params] = useSearchParams();

  useEffect(() => {
    var currentLang: any = localStorage.getItem("language");
    i18n.language = currentLang;
    if (isLogin) {
      localStorage.clear();
      window.location.reload();
    }
  }, [i18n, isLogin]);

  const onFinish = (values: any) => {
    if (!values.password) {
      formRef?.current?.setFields([
        {
          name: "password",
          errors: ["Password is require"],
        },
      ]);
      return;
    }
    if (!values.confirmPassword) {
      formRef?.current?.setFields([
        {
          name: "confirmPassword",
          errors: ["Confirm password is require!"],
        },
      ]);
      return;
    }

    if (values.confirmPassword.trim() === values.password.trim()) {
      if (values.confirmPassword.length < 8) {
        formRef?.current?.setFields([
          {
            name: "password",
            errors: ["Password must be 8 character!"],
          },
        ]);
      }
      api
        .POST(pathAPI.forgetPassword, {
          password: values.password,
          session: params.get("session"),
        })
        .then((res) => {
          setMessage(res.data ? res.data?.content || "" : "");
        })
        .catch((err: Error) => {
          messageNoti.error(err.message || "Something went wrong!");
        });
    } else {
      formRef?.current?.setFields([
        {
          name: "confirmPassword",
          errors: ["Confirm password mot match!"],
        },
      ]);
    }
  };

  return (
    <LightScope>
    <div className="flex justify-center items-center h-screen bg-pink-200">
      <div className="w-[400px] shadow-xl rounded-[20px]">
        <Card
          title={"Reset Password"}
          className="[&_.ant-card-bordered]:border-none [&_.ant-card-bordered]:rounded-[10px] [&_.ant-card-head]:rounded-t-[10px] [&_.ant-card-head]:bg-[#ba2156] [&_.ant-card-head]:text-white [&_.ant-card-head]:text-center [&_.ant-select-selector]:h-10"
        >
          {message && (
            <Box>
              <Box mb={2} fontSize={16} textAlign={"center"}>
                {message}
              </Box>
              <Link className="text-[#ba2156] hover:text-[#9a1a46] text-center block" to="/login">
                {t("btn.sign_in")}
              </Link>
            </Box>
          )}
          {!message && (
            <Form
              ref={formRef}
              name="normal_login"
              className="login-form"
              initialValues={{ remember: true }}
              onFinish={onFinish}
            >
              <Form.Item
                name="password"
                label="Password"
                rules={[{ required: true, message: "Password is require!" }]}
                wrapperCol={{ span: 24 }}
                labelCol={{ span: 24 }}
              >
                <PasswordField placeholder="Password" />
              </Form.Item>
              <Form.Item
                name="confirmPassword"
                label="Confirm Password"
                rules={[
                  { required: true, message: "Confirm password is require!" },
                ]}
                wrapperCol={{ span: 24 }}
                labelCol={{ span: 24 }}
              >
                <PasswordField placeholder="Confirm Password" />
              </Form.Item>

              <Form.Item>
                <ActionButton appSize="large" type="submit" sx={{ width: "50%" }}>
                  Submit
                </ActionButton>
              </Form.Item>
            </Form>
          )}
        </Card>
      </div>
    </div>
    </LightScope>
  );
};
export default ResetPassword;
